import { render } from "./SetPricePopupComponent.vue?vue&type=template&id=4054b7ff&scoped=true"
import script from "./SetPricePopupComponent.vue?vue&type=script&lang=js"
export * from "./SetPricePopupComponent.vue?vue&type=script&lang=js"

import "./SetPricePopupComponent.vue?vue&type=style&index=0&id=4054b7ff&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4054b7ff"

export default script